var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"gmp-page gmp-page--no-newsletter"},[_c('MEM_heroLanding'),_c('MEM_highLights',{attrs:{"clientWidth":_vm.clientWidth}}),_c('MemberProduct',{attrs:{"clientWidth":_vm.clientWidth}}),_c('div',[_vm._v("market")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }